export default __webpack_public_path__ + "static/services_gif-e8ba894b7bc94f097c71bccac718e91e.mp4";